<template>
  <!-- NOTE (TEMPLATE) to show the proposal review -->

  <div class="animated fadeIn">
    <!-- loading component -->
    <Loading />
    <PostDoc role="referee" />
  </div>
</template>

<script>
const PostDoc = () => import("../../components/PostDoc");

export default {
  components: { PostDoc } // NOTE (COMPONENT) component of proposal
};
</script>

<style>
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("../../assets/fonts/IRANSans(FaNum).ttf");
}
</style>
<style scoped>
.color {
  background-color: #0c4961;
  color: white;
}
</style>
